import React from "react";
import PromoBanner from "../../components/PromoBanner";

const Home: React.FC = () => {
    return (
        <div className="min-h-screen relative">
            <PromoBanner />
            {/* Hero image - plein ecran sur mobile, ratio d'origine conserve a partir de md */}
            <div className="relative w-full overflow-hidden h-screen md:h-auto md:aspect-[1536/1024]">
                <img
                    src="/bg.png"
                    alt="Gas Station"
                    className="absolute inset-0 w-full h-full object-cover"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/30"></div>

                {/* Animated background elements */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
                </div>

                {/* Horaires */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 flex items-center space-x-2 bg-black/70 border border-accent/30 rounded-full px-5 py-2.5 backdrop-blur-sm">
                    <svg className="w-4 h-4 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-gray-300 text-sm">24/24 Commandes prises en charge de <span className="text-accent font-semibold">12h à 02h</span></span>
                </div>
            </div>
        </div>
    );
};

export default Home;
